<header class="shadow-sm border-b sticky top-0 z-50 bg-(--header-background)">
  <!-- ส่งค่า showSidebar ไปยัง component sidebar -->
  <app-sidebar *ngIf="showSidebar" (showSidebarChange)="onChangeMenuStatus($event)"></app-sidebar>
  <div class="px-4 py-3 flex items-center justify-between relative w-full">

    <!-- โลโก้ -->
    <div>
      <img src="/images/element-24.png" alt="City Parking Logo" class="h-10 md:h-12" />
    </div>
    <!-- ปุ่มเปิดเมนู -->
    <div class="flex items-center justify-center space-x-4">
      <!----------------------- แจ้งเตือน --------------------->
      <div class="relative">
        <div class="relative">
          <!------ ปุ่มรูปภาพ ------>
          <!-- <div class="w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-sm"
              (click)="toggleModal('notification')"
          >
            <div class="w-8 h-8">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADA0lEQVR4nO2dPWsUURSGbxNLFRQVLEL2nt3EtPkVCmJrYSvEwkLUxspSiPED/4wfpQqCi0r2npgo/gRBE4OouefIxEYI+ZhJlnfOnfPAKZfceZ65eyfNTgiO4ziO4ziO4zgtRZi0zqDXWxziAbCIB8AiHgCLeAAs4gGwiAfAIh4Ah64MTtYNUH0GvW7T6JfeMWW6lple5USbdQNUn8lML5VpXj/RUfT1mEGXpk5npvuZ44+60neMwXE9J1rQD71T6OtrLTqcm1COtypZhyV++66Ia5rizepvoa+3VejKYCozvR6X+O07gt4q9/ro624FOqKL47zrd90N3LsQuowyzTc5YA8vAm1qildDF9l6wkkkKPn/RZDORVDunUfe+bI9QlaOl0IX0I/T04jvfNnfmVD2waxp9khO8R1atuy8E4ZFP6IqxztoybLHKPdvhxLR1f7ZzLSBFix77QKO65omz4TSyExP0HJl3xFoMZSELs+cyIl+Ggqwoe8nj4dS0EQ30FKl5miK10MpVE8XaKFSdxek+CYUc/i24D9eqR2AchGHsTJdQcuUhqPLvcvBOjnFx2iR0ngXxIfBOjnFF2YDMD0N1slMn+3uAFoN1smJvtndAfFrsE7m+NtwgF/BOmiJcsAJ1kELFA+AlygewO4E66AFigfASxQPYHeCddACxQPgJYoHsDvBOmiB4gHwEsUD2J1gHbRA8QB4ieIB7E6wDlqgeAC8RPEAdidYBy1QPABeongAuxOsgxYoHgAvUboaIHO8ixYoB5zM8V6wSAnyxWqEkuSLtQglyhcrEUqWL22P0AX50tYIXZIvbYvQRfnSpghoCQIetH8PgAYtQDwAXoJ0OYDjOI7jjIuc4lrTAzKn+B29fvPkRKl5ABqh12+ezPHBAQIsoNdvHk002+gNGhz/6NJgBr3+IsgNfvSp2jnodReDDucmcorPa8h/VvRPEAMjPKq+Wnb72qnufJc/7jOBabF6wtl6Oc+/F/SMqhf/6Kh/Dr0+x3Ecx3Ecx3GcsAd/ARUepsxqJzF4AAAAAElFTkSuQmCC" alt="bell">
            </div>
          </div> -->
          <!----- แจ้งเตือน จํานวน ---->
          <!-- <div class="absolute top-[-5px] right-[-5px] w-4 h-4 bg-red-500 rounded-full flex justify-center items-center">
            <label class="text-white text-[10px]">4</label>
          </div> -->
        </div>
        <!------- Box Notification ------->
        <div class="absolute top-10 right-[-10px] w-[250px] h-[200px] bg-white shadow-lg rounded-md"
          *ngIf="isNotification">
          <!------ List ------>
          <div class="relative w-full h-[150px] overflow-y-scroll">
            <div class="w-full h-[50px] relative flex flex-col item-center" *ngFor="let item of listNotification">
              <div class="w-full h-[60px] flex items-center border-b border-gray-200">
                <div class="w-1/3 h-full flex items-center justify-center">
                  <img src="/icons/charge-home.png" class="w-6 h-6">
                </div>
                <div class="w-2/3 h-full flex items-center justify-center">
                  <label class="text-[14px] font-medium text-gray-600">
                    {{ item.data }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!------ Footer ------>
          <div class="w-full h-[50px] flex items-center justify-center border-t border-gray-200"
            style="box-shadow: 0px -4px 4px rgba(206, 205, 205, 0.25);"
            (click)="navigateRoute('notification' , '/notification')">
            <!-- <button class="text-[14px] font-medium text-gray-600">
              <label class="underline cursor-pointer">{{ currentLang === "TH" ? "ดูทั้งหมด" : "See all" }}</label>
            </button> -->
          </div>

        </div>
      </div>
      <!------------------------- Menu ------------------------->
      <button (click)="toggleModal('menu')" class="text-white flex items-center">
        <img src="icons/menu_white.svg" class="w-7 h-7" />
      </button>
    </div>


  </div>
</header>